<div class="card h-100">
  <div class="card-header bg-white border-bottom">
    <h6 class="mb-0">Misconfigured Identities</h6>
    <span class="text-muted small">Identities with posture gaps, sorted by escalation impact</span>
  </div>
  <div class="card-body p-0">
    @if (isLoading()) {
      <div class="d-flex justify-content-center align-items-center py-4">
        <div class="spinner-border spinner-border-sm text-primary" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    } @else if (unavailable()) {
      <div class="text-center text-muted py-4">
        <div class="mb-1">Not available yet</div>
      </div>
    } @else if (identityRisks().length === 0) {
      <div class="text-center text-muted py-4">
        <div class="mb-1">No escalated identities in the last 30 days</div>
      </div>
    } @else {
      @for (risk of identityRisks(); track risk.identity_id; let i = $index) {
        <div class="risk-row" (click)="onOpenDetails(risk)">
          <div class="d-flex align-items-center gap-2">
            <span class="risk-rank">{{ i + 1 }}</span>
            <span class="risk-icon">
              <kendo-svg-icon [icon]="getIdentityTypeIcon(risk.identity_type)"></kendo-svg-icon>
            </span>
            <div class="risk-identity">
              <span class="fw-semibold small">{{ risk.identity }}</span>
              <span class="text-muted" style="font-size: 0.7rem">
                {{ risk.identity_type }}
                @if (showsAppId(risk)) {
                  · App ID {{ risk.identity_id | slice: 0 : 8 }}
                }
              </span>
            </div>
            <div class="ms-auto text-end">
              @if (risk.escalation_count_30d > 0) {
                <div class="escalation-count fw-bold">{{ risk.escalation_count_30d }}</div>
                <span class="text-muted" style="font-size: 0.6rem">escalations (30d)</span>
              } @else {
                <span class="text-muted small">No escalations</span>
              }
            </div>
          </div>

          <!-- Misconfig badges -->
          <div class="d-flex flex-wrap gap-1 mt-2">
            @for (mc of risk.misconfigs; track mc.check_id) {
              <span class="misconfig-tag misconfig-tag--{{ mc.severity | lowercase }}">{{ mc.check_name }}</span>
            }
          </div>
        </div>
      }
    }
  </div>
</div>

@if (dialogVisible() && selectedRisk(); as risk) {
  <kendo-dialog
    (close)="onDialogClose()"
    [width]="'600px'"
    [minWidth]="'400px'"
  >
    <kendo-dialog-titlebar>
      <div class="d-flex align-items-center gap-2">
        <span class="risk-icon risk-icon--dialog">
          <kendo-svg-icon [icon]="getIdentityTypeIcon(risk.identity_type)"></kendo-svg-icon>
        </span>
        <div style="min-width: 0">
          <div class="fw-semibold text-truncate">{{ risk.identity }}</div>
          <div class="text-muted small">{{ risk.identity_type }}</div>
        </div>
      </div>
    </kendo-dialog-titlebar>

    <div class="dialog-body">
      <!-- Summary metrics -->
      <div class="row g-3 mb-3">
        <div class="col-4">
          <div class="summary-metric">
            <div class="summary-metric__value">{{ risk.misconfigs.length }}</div>
            <div class="summary-metric__label">Misconfigurations</div>
          </div>
        </div>
        <div class="col-4">
          <div class="summary-metric">
            <div class="summary-metric__value">{{ risk.escalation_count_30d }}</div>
            <div class="summary-metric__label">Escalations (30d)</div>
          </div>
        </div>
        <div class="col-4">
          <div class="summary-metric">
            <div class="summary-metric__value">
              <span class="badge {{ getSeverityClass(getMaxSeverity(risk)) }}">{{ getMaxSeverity(risk) }}</span>
            </div>
            <div class="summary-metric__label">Highest Severity</div>
          </div>
        </div>
      </div>

      @if (risk.identity_type === 'Service Account') {
        <div class="mb-3">
          <div class="text-muted small fw-medium mb-1">App ID</div>
          <div class="small font-monospace">{{ risk.identity_id }}</div>
        </div>
      }

      <!-- Detection Type -->
      @if (risk.alert_categories.length > 0) {
        <div class="mb-3">
          <div class="text-muted small fw-medium mb-1">Detection Type</div>
          <div class="d-flex flex-wrap gap-1">
            @for (cat of risk.alert_categories; track cat) {
              <span class="badge bg-light text-dark border">{{ cat }}</span>
            }
          </div>
        </div>
      }

      <!-- Misconfigurations list -->
      <div class="text-muted small fw-medium mb-2">Posture gaps</div>
      @for (mc of risk.misconfigs; track mc.check_id) {
        <div class="misconfig-row">
          <div class="d-flex align-items-center justify-content-between">
            <span class="fw-medium small">{{ mc.check_name }}</span>
            <span [class]="getSeverityClass(mc.severity)">{{ mc.severity }}</span>
          </div>
        </div>
      }
    </div>
  </kendo-dialog>
}
